<template lang="pug">
page-template(title="Vagas de Trabalho")
  .vacancies-list.mx-auto(v-if="vacancies.length")
    v-card.vacancy-card.mb-4(
      v-for="vacancy in vacancies",
      :key="vacancy.id",
      outlined
    )
      .d-flex.align-center.flex-wrap.pa-4
        .vacancy-card__content.flex-grow-1
          .text-subtitle-1.font-weight-bold.primary--text {{ vacancy.title }}
          .grey--text.text--darken-1.mt-1
            v-icon.mr-1(small, color="grey darken-1") fas fa-map-marker-alt
            span {{ vacancy.store.title }}
        .d-flex.flex-wrap.mt-3.mt-sm-0
          v-btn.mr-2(
            v-if="vacancy.text",
            depressed,
            outlined,
            color="primary",
            @click="openDetails(vacancy)"
          ) Detalhes
          v-btn.primary.white--text(
            depressed,
            :to="`/trabalhe-conosco?loja=${vacancy.store.id}&vaga=${vacancy.id}`"
          ) Candidatar-se
  .text-center.grey--text.text--darken-1(v-else) Nenhuma vaga disponível no momento.

  v-dialog(v-model="detailsOpen", max-width="640")
    v-card(v-if="selectedVacancy")
      v-card-title.primary.white--text {{ selectedVacancy.title }}
      v-card-text.pt-4
        .grey--text.text--darken-1.mb-4
          v-icon.mr-1(small, color="grey darken-1") fas fa-map-marker-alt
          span {{ selectedVacancy.store.title }}
        .ck-content(v-html="selectedVacancy.text")
      v-card-actions
        v-spacer
        v-btn(text, @click="detailsOpen = false") Fechar
        v-btn.primary.white--text(
          depressed,
          :to="`/trabalhe-conosco?loja=${selectedVacancy.store.id}&vaga=${selectedVacancy.id}`"
        ) Candidatar-se
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";

export default {
  data: () => ({
    detailsOpen: false,
    selectedVacancy: null,
  }),
  computed: {
    vacancies() {
      return this.$rest("vacancies").list;
    },
  },
  methods: {
    openDetails(vacancy) {
      this.selectedVacancy = vacancy;
      this.detailsOpen = true;
    },
  },
  beforeCreate() {
    this.$rest("vacancies").get();
  },
  components: {
    PageTemplate,
  },
};
</script>

<style>
.vacancies-list {
  max-width: 800px;
}
.vacancy-card {
  transition: box-shadow 0.2s, transform 0.2s;
}
.vacancy-card:hover {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12) !important;
}
</style>
